<template>
  <div class="page-wrapper mt-3" style="width: 100%">
    <PageTitle title="Конструктор курсов и учебных модулей" />

    <TogglerOfWrapper>
      <template v-slot:name>Подсказка по управлению</template>
      <template v-slot:content>
        <p class="mb-3">В данном разделе вы можете создавать учебные курсы, распределять их по модулям и закреплять за ними студенческие группы.</p>
        <p><strong>Важно:</strong> При создании модуля вы можете привязать к нему ИИ-промпт из библиотеки. Все эссе, отправленные студентами в этот модуль, будут автоматически отправлены на автопроверку в LLM по заданным критериям.</p>
      </template>
    </TogglerOfWrapper>

    <div class="d-flex justify-start align-center ma-2">
      <AppButton @click="openCourseDialog()" class="bordered-item">
        <v-icon start>mdi-plus</v-icon> Создать курс
      </AppButton>
    </div>

    <!-- ДЕРЕВО КУРСОВ И МОДУЛЕЙ через Expansion Panels -->
    <v-expansion-panels class="ma-2" variant="accordion">
      <v-expansion-panel v-for="course in courses" :key="course.id" class="mb-2 border rounded">
        <v-expansion-panel-title>
          <div class="d-flex justify-space-between align-center w-100 pr-4">
            <div>
              <span class="text-h6 font-weight-bold text-primary">{{ course.courseName }}</span>
              <span class="text-caption text-grey ml-4 d-block d-sm-inline">
                Сроки: {{ formatDateTime(course.courseStartTime) }} — {{ formatDateTime(course.courseEndTime) }}
              </span>
            </div>
            <!-- Кнопки быстрого управления курсом -->
            <div @click.stop>
              <v-btn
                icon="mdi-pencil-outline"
                variant="text"
                color="deep-orange-darken-1 "
                size="small"
                @click="openCourseDialog(course)"
                title="Редактировать курс"
              ></v-btn>
              <v-btn
                prepend-icon="mdi-plus"
                color="deep-orange-darken-1 "
                variant="flat"
                size="small"
                class="ml-2"
                @click="openModuleDialog(course.id)"
              >
                Добавить модуль
              </v-btn>
            </div>
          </div>
        </v-expansion-panel-title>


        <v-expansion-panel-text class="bg-grey-lighten-5 pa-2">
          <p class="text-body-1 text-grey-darken-3 mb-3 font-italic">{{ course.courseDescription || 'Описание курса отсутствует.' }}</p>

          <!-- Список привязанных групп пользователей (ManyToMany) -->
          <div class="mb-4">
            <span class="text-subtitle-2 font-weight-bold text-grey-darken-2 d-block mb-1">Закрепленные студенческие группы:</span>
            <div class="d-flex flex-wrap gap-2">
              <v-chip
                v-for="group in course.coursePersonGroups"
                :key="group.id"
                size="small"
                color="blue-darken-2"
                variant="tonal"
                prepend-icon="mdi-account-group-outline"
              >
                {{ group.groupName }}
              </v-chip>
              <span v-if="!course.coursePersonGroups || course.coursePersonGroups.length === 0" class="text-caption text-error font-weight-bold">
                <v-icon start size="small">mdi-alert-circle-outline</v-icon> Внимание: К курсу не привязана ни одна группа студентов!
              </span>
            </div>
          </div>

          <v-divider class="my-3"></v-divider>

          <!-- СПИСОК МОДУЛЕЙ ВНУТРИ КУРСА -->
          <span class="text-subtitle-1 font-weight-bold d-block mb-2 text-deep-orange-darken-1 ">Структура учебных модулей:</span>

            <v-card
            v-for="mod in course.modules"
            :key="mod.id"
            variant="flat"
            class="border rounded-lg bg-white w-100 pa-4 ma-2">
             <!-- Шапка модуля (Аватар, название и кнопки управления) -->
                          <div class="d-flex justify-space-between align-start flex-wrap gap-3 w-100 mb-3">
                            <div class="d-flex align-start gap-3">
                              <v-avatar color="primary-lighten-5" rounded size="large" class="mt-1 flex-shrink-0">
                                <v-icon color="primary">mdi-folder-text-outline</v-icon>
                              </v-avatar>
                              <div>
                                <div class="font-weight-bold text-h6 text-grey-darken-4">{{ mod.courseModuleName }}</div>
                                <div class="text-body-2 text-grey-darken-2 mt-1">
                                  {{ mod.courseModuleDescription || 'Инструкция для студентов отсутствует.' }}
                                </div>
                              </div>
                            </div>

                            <!-- Кнопки действий модуля (справа) -->
                            <div class="d-flex align-center gap-1 flex-shrink-0">
                              <v-btn
                                size="small"
                                icon="mdi-cog-outline"
                                variant="text"
                                color="deep-orange-darken-1 "
                                @click="openModuleDialog(course.id, mod)"
                                title="Настройки"
                              ></v-btn>
                              <v-btn
                                size="small"
                                variant="outlined"
                                color="deep-orange-darken-1"
                                @click="addSubjectDialog(mod)"
                                title="Добавить предмет"
                              >Добавить предмет</v-btn>
                              <v-btn
                                size="small"
                                variant="text"
                                color="deep-orange-darken-1 "
                                @click="openVideoDialog(mod)"
                                title="Видео"
                              >Видео</v-btn>
                            </div>
                          </div>

                          <!-- Временные метки и статус ИИ -->
                          <div class="d-flex flex-wrap align-center gap-4 text-caption text-grey-darken-1 bg-grey-lighten-5 pa-2 rounded-md border mb-4">
                            <span><v-icon size="x-small" start>mdi-calendar-play</v-icon> Старт: {{ formatDateTime(mod.courseModuleStartTime) }}</span>
                            <span class="text-red-darken-1 font-weight-bold"><v-icon size="x-small" start color="red-darken-1">mdi-calendar-clock</v-icon> Дедлайн: {{ formatDateTime(mod.courseModuleEndTime) }}</span>
                            <v-spacer class="hidden-sm-and-down"></v-spacer>
                          </div>
                          <v-divider class="my-3"></v-divider>
            <!-- БЛОК ПРЕДМЕТОВ И ПРОБ ВНУТРИ МОДУЛЯ -->
            <div class="mt-4  w-100" style="display: block; min-width: 100%;">
              <div class="text-subtitle-2 font-weight-bold text-grey-darken-3 mb-3 d-flex align-center">
                <v-icon size="small" class="mr-2" color="deep-orange-darken-1 ">mdi-book-open-variant</v-icon>
                Предметы модуля
              </div>
              <!-- Если предметы есть — выводим их обычным списком блоков с разделителями (gap) -->
              <div v-if="mod.subjects && mod.subjects.length > 0" class="d-flex flex-column gap-3 w-100">
                <div v-for="s in mod.subjects" :key="s.id" class="w-100">
                  <v-card
                    variant="outlined"
                    class="rounded-lg bg-white w-100 d-flex flex-column justify-space-between custom-subject-card"
                  >
                    <!-- 1. ВЕРХНЯЯ ЧАСТЬ (Название предмета и кнопки управления) -->
                    <div class="pa-4 w-100">
                      <div class="d-flex justify-space-between align-start gap-2 w-100">
                        <div class="overflow-hidden" style="max-width: 75%;">
                          <div class="text-h6 font-weight-bold text-teal-darken-3 line-height-tight text-truncate" :title="s.courseModuleSubjectName">
                            {{ s.courseModuleSubjectName }}
                          </div>
                          <div v-if="s.courseModuleSubjectDescription" class="text-caption text-grey-darken-1 mt-1 text-truncate" :title="s.courseModuleSubjectDescription">
                            {{ s.courseModuleSubjectDescription }}
                          </div>
                        </div>

                        <!-- Блок кнопок управления предметом -->
                        <div class="d-flex align-center gap-1 flex-shrink-0">
                          <v-btn
                            size="x-small"
                            variant="tonal"
                            color="teal-darken-2"
                            prepend-icon="mdi-plus"
                            @click="addProbaDialog(s)"
                            title="Добавить пробу в предмет"
                          >
                            Проба
                          </v-btn>
                          <v-btn
                            icon="mdi-pencil-outline"
                            variant="text"
                            color="grey-darken-1"
                            size="small"
                            @click="editSubject(s)"
                            title="Редактировать пробу"
                          ></v-btn>

                          <v-btn
                            icon="mdi-delete-outline"
                            variant="text"
                            color="error"
                            size="small"
                            @click="deleteSubject(s.id)"
                            title="Удалить предмет"
                          ></v-btn>
                        </div>
                      </div>
                    </div>

                    <!-- 2. НИЖНЯЯ ЧАСТЬ (Секция проб) -->
                    <div class="px-4 pb-4 pt-0 w-100">
                      <div class="bg-grey-lighten-5 rounded-lg pa-3 border-dashed w-100">
                        <div class="text-caption font-weight-bold text-grey-darken-2 mb-2 d-flex align-center">
                          <v-icon size="x-small" class="mr-1" color="grey">mdi-format-list-bulleted</v-icon>
                          Пробы / Испытания:
                        </div>

                        <!-- Список проб -->
                        <div v-if="s.probes && s.probes.length > 0" class="d-flex flex-column gap-2 w-100">
                          <v-card
                            v-for="proba in s.probes"
                            :key="proba.id"
                            variant="flat"
                            class="bg-white border rounded-lg px-4 py-3 d-flex flex-column gap-2 elevation-sm w-100 custom-proba-card"
                          >
                            <!-- Верхняя строка: Номер, Название и кнопки управления -->
                            <div class="d-flex justify-space-between align-center w-100">
                              <div class="d-flex align-center gap-2 overflow-hidden">
                                <!-- Порядковый номер пробы -->
                                <v-chip size="x-small" color="teal-darken-2" variant="flat" class="font-weight-bold flex-shrink-0">
                                  #{{ proba.probeOrder || 1 }}
                                </v-chip>
                                <!-- Название пробы -->
                                <span class="text-body-1 font-weight-bold text-grey-darken-4 text-truncate">
                                  {{ proba.probeName }}
                                </span>
                              </div>

                              <!-- Кнопки управления пробой -->
                              <div class="d-flex flex-shrink-0 align-center gap-1">
                                <v-btn
                                  icon="mdi-pencil-outline"
                                  variant="text"
                                  color="grey-darken-1"
                                  size="small"
                                  @click="editProbe(proba)"
                                  title="Редактировать пробу"
                                ></v-btn>
                                <v-btn
                                  icon="mdi-trash-can-outline"
                                  variant="text"
                                  color="error"
                                  size="small"
                                  @click="deleteProbe(proba.id)"
                                  title="Удалить пробу"
                                ></v-btn>
                              </div>
                            </div>

                            <!-- Средняя строка: Описание пробы (если оно есть) -->
                            <div v-if="proba.probeDescription" class="text-body-2 text-grey-darken-2 bg-grey-lighten-5 pa-2 rounded custom-description-block">
                              {{ proba.probeDescription }}
                            </div>

                            <!-- Нижняя строка: Даты проведения и индикатор ИИ-промпта -->
                            <div class="d-flex flex-wrap align-center justify-space-between gap-2 text-caption pt-1 text-grey-darken-1 border-top-light">
                              <!-- Сроки сдачи -->
                              <div class="d-flex align-center flex-wrap gap-3">
                                <span>
                                  <v-icon size="x-small" color="grey" class="mr-1">mdi-calendar-play</v-icon>
                                  Прием с: <strong class="text-grey-darken-3">{{ formatDateTime(proba.startTime) }}</strong>
                                </span>
                                <span>
                                  <v-icon size="x-small" color="error" class="mr-1">mdi-calendar-clock</v-icon>
                                  Дедлайн: <strong class="text-red-darken-2">{{ formatDateTime(proba.endTime) }}</strong>
                                </span>
                              </div>

                              <!-- Информация о привязанном промпте -->
                              <div>
                                <v-chip
                                  v-if="proba.promptId && proba.promptName"
                                  size="x-small"
                                  color="purple-lighten-5"
                                  text-color="purple-darken-2"
                                  variant="flat"
                                  class="font-weight-medium"
                                  prepend-icon="mdi-robot-outline"
                                >
                                  Промпт: {{ proba.promptName }}
                                </v-chip>
                                <v-chip
                                  v-else
                                  size="x-small"
                                  color="amber-lighten-5"
                                  text-color="amber-darken-3"
                                  variant="flat"
                                  class="font-weight-medium"
                                  prepend-icon="mdi-account-check-outline"
                                >
                                  Ручная проверка
                                </v-chip>
                              </div>
                            </div>
                          </v-card>
                        </div>
                      </div>
                    </div>
                  </v-card>

                </div>
              </div>

              <!-- Если предметов нет вообще -->
              <div v-else class="text-caption text-grey font-italic pa-3 bg-grey-lighten-4 rounded-lg border text-center w-100">
                <v-icon size="small" start class="mr-1">mdi-information-outline</v-icon> Предметы не добавлены
              </div>
            </div>
            </v-card>
            <v-list-item v-if="!course.modules || course.modules.length === 0">
              <v-list-item-title class="text-grey text-center text-caption py-4 font-italic">
                <v-icon start size="small">mdi-information-outline</v-icon> В этом курсе еще не создано ни одного учебного модуля.
              </v-list-item-title>
            </v-list-item>
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-alert v-if="courses.length === 0" type="info" variant="tonal" class="w-100 mt-2">
        Список курсов пуст. Нажмите кнопку «Создать курс» сверху, чтобы начать формирование структуры обучения.
      </v-alert>
    </v-expansion-panels>


    <!-- МОДАЛКА: Создание/Редактирование КУРСА -->
    <v-dialog v-model="courseDialog" max-width="650px" persistent>
      <v-card class="pa-2">
        <v-card-title class="text-h5 font-weight-bold">
          {{ courseForm.id ? 'Редактирование параметров курса' : 'Регистрация нового курса' }}
        </v-card-title>
        <v-card-text>
          <v-text-field v-model="courseForm.courseName" label="Название курса*" variant="outlined" required class="mb-3"></v-text-field>
          <v-textarea v-model="courseForm.courseDescription" label="Общее описание курса" variant="outlined" rows="3" class="mb-3" hide-details></v-textarea>

          <v-row class="mt-1">
            <v-col cols="12" sm="6">
              <v-text-field v-model="courseForm.courseStartTime" type="datetime-local" label="Дата и время начала*" variant="outlined" required></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field v-model="courseForm.courseEndTime" type="datetime-local" label="Дата и время окончания*" variant="outlined" required></v-text-field>
            </v-col>
          </v-row>

          <!-- Выбор групп студентов (ManyToMany) -->
          <v-select
            v-model="courseForm.personGroupIds"
            :items="availableGroups"
            item-title="personGroupName"
            item-value="id"
            label="Закрепить учебные группы студентов"
            multiple
            chips
            closable-chips
            variant="outlined"
            prepend-inner-icon="mdi-account-group"
            class="mt-2"
          ></v-select>
        </v-card-text>
        <v-card-actions class="px-6 pb-4">
          <v-spacer></v-spacer>
          <v-btn color="grey-darken-1" variant="text" @click="courseDialog = false">Отмена</v-btn>
          <v-btn color="deep-orange-darken-1" variant="flat" :disabled="!courseForm.courseName || !courseForm.courseStartTime || !courseForm.courseEndTime" @click="saveCourse()">Сохранить</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

<!-- МОДАЛКА: Создание/Редактирование КУРСА -->
    <v-dialog v-model="courseDialog" max-width="650px" persistent>
      <v-card>
        <v-card-title class="text-deep-orange-darken-1">
          {{ courseForm.id ? 'Редактирование параметров курса' : 'Регистрация нового курса' }}
        </v-card-title>
        <v-card-text>
          <v-text-field v-model="courseForm.courseName" label="Название курса*" variant="outlined" required class="mb-3"></v-text-field>
          <v-textarea v-model="courseForm.courseDescription" label="Общее описание курса" variant="outlined" rows="3" class="mb-3" hide-details></v-textarea>

          <v-row class="mt-1">
            <v-col cols="12" sm="6">
              <v-text-field v-model="courseForm.courseStartTime" type="datetime-local" label="Дата и время начала*" variant="outlined" required></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field v-model="courseForm.courseEndTime" type="datetime-local" label="Дата и время окончания*" variant="outlined" required></v-text-field>
            </v-col>
          </v-row>

          <!-- Выбор групп студентов (ManyToMany) -->
          <v-select
            v-model="courseForm.personGroupIds"
            :items="availableGroups"
            item-title="personGroupName"
            item-value="id"
            label="Закрепить учебные группы студентов"
            multiple
            chips
            closable-chips
            variant="outlined"
            prepend-inner-icon="mdi-account-group"
            class="mt-2"
          ></v-select>
        </v-card-text>
        <v-card-actions class="px-6 pb-4">
          <v-spacer></v-spacer>
          <v-btn color="grey-darken-1" variant="text" @click="courseDialog = false">Отмена</v-btn>
          <v-btn color="deep-orange-darken-1 " variant="flat" :disabled="!courseForm.courseName || !courseForm.courseStartTime || !courseForm.courseEndTime" @click="saveCourse()">Сохранить</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- МОДАЛКА: Создание/Редактирование МОДУЛЯ С ПОДВЯЗКОЙ ПРОМПТА -->
    <v-dialog v-model="moduleDialog" max-width="650px" persistent>
      <v-card class="pa-2">
        <v-card-title class="text-h5 font-weight-bold">
          {{ moduleForm.id ? 'Параметры учебного модуля' : 'Добавление нового учебного модуля' }}
        </v-card-title>
        <v-card-text>
          <v-text-field v-model="moduleForm.courseModuleName" label="Название модуля*" variant="outlined" required class="mb-3"></v-text-field>
          <v-textarea v-model="moduleForm.courseModuleDescription" label="Инструкция / Задание для магистрантов" variant="outlined" rows="3" class="mb-3" hide-details></v-textarea>

          <v-row class="mt-1">
            <v-col cols="12" sm="6">
              <v-text-field v-model="moduleForm.courseModuleStartTime" type="datetime-local" label="Начало приема работ*" variant="outlined" required></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field v-model="moduleForm.courseModuleEndTime" type="datetime-local" label="Окончание приема (Дедлайн)*" variant="outlined" required></v-text-field>
            </v-col>
          </v-row>


        </v-card-text>
        <v-card-actions class="px-6 pb-4">
          <v-spacer></v-spacer>
          <v-btn color="grey-darken-1" variant="text" @click="moduleDialog = false">Отмена</v-btn>
          <v-btn color="deep-orange-darken-1 " variant="flat" :disabled="!moduleForm.courseModuleName || !moduleForm.courseModuleStartTime || !moduleForm.courseModuleEndTime" @click="saveModule()">Сохранить</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

<!-- МОДАЛКА: Создание/Редактирование МОДУЛЯ Предмета -->
    <v-dialog v-model="courseSubjectDialog" max-width="650px" persistent>
      <v-card >
        <v-card-title  class="bg-deep-orange-darken-1  py-4 text-white ">
          {{ courseSubject.id ? 'Параметры предмета учебного модуля' : 'Добавление нового предмета учебного модуля' }}
        </v-card-title>
        <v-card-text>
          <v-text-field v-model="courseSubject.courseModuleSubjectName" label="Название предмета*" variant="outlined" required class="mb-3"></v-text-field>
          <v-textarea v-model="courseSubject.courseModuleSubjectDescription" label="Описание предмета" variant="outlined" rows="3" class="mb-3" hide-details></v-textarea>

          <v-row class="mt-1">
            <v-col cols="12" sm="6">
              <v-text-field v-model="courseSubject.startTime" type="datetime-local" label="Начало приема работ*" variant="outlined" required></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field v-model="courseSubject.endTime" type="datetime-local" label="Окончание приема (Дедлайн)*" variant="outlined" required></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="px-6 pb-4">
          <v-spacer></v-spacer>
          <v-btn color="grey-darken-1" variant="text" @click="courseSubjectDialog = false">Отмена</v-btn>
          <v-btn color="deep-orange-darken-1 " variant="flat" :disabled="!courseSubject.courseModuleSubjectName || !courseSubject.courseModuleSubjectDescription" @click="saveSubject()">Сохранить</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

<!-- МОДАЛКА: Создание/Редактирование МОДУЛЯ Предмета -->
    <v-dialog v-model="probeDialog" max-width="700px" persistent>
      <v-card class="rounded-lg elevation-4">
        <!-- Шапка диалога с иконкой -->
        <v-card-item class="bg-deep-orange-darken-1  py-4 text-white">
          <div class="d-flex align-center gap-2">
            <v-icon :icon="subjectProbe.id ? 'mdi-pencil-box-outline' : 'mdi-plus-box-outline'" size="large"></v-icon>
            <v-card-title class="text-h5 font-weight-bold pa-0 line-height-tight ">
              {{ subjectProbe.id ? 'Параметры пробы' : 'Новая проба предмета' }}
            </v-card-title>
          </div>
        </v-card-item>

        <v-divider></v-divider>

        <!-- Основной контент формы -->
        <v-card-text class="pa-6">
          <v-row dense>
            <!-- Название пробы -->
            <v-col cols="12" sm="12">
              <v-text-field
                v-model="subjectProbe.probeName"
                label="Название пробы*"
                variant="outlined"
                required
                color="primary"
                density="comfortable"
              ></v-text-field>
            </v-col>

           <!-- Порядковый номер пробы через селектор от 1 до 5 -->
           <v-col cols="12" sm="6">
             <v-select
               v-model="subjectProbe.probeOrder"
               :items="[1, 2, 3, 4, 5]"
               label="Порядок*"
               variant="outlined"
               required
               color="primary"
               density="comfortable"
               hint="№ в списке"
               persistent-hint
             ></v-select>
           </v-col>
        <v-col cols="12" sm="6">
                    <v-select
                      v-model="subjectProbe.attemptCount"
                      :items="[1, 2, 3, 4, 5]"
                      label="Попыток*"
                      variant="outlined"
                      required
                      color="primary"
                      density="comfortable"
                      hint="Попыток"
                      persistent-hint
                    ></v-select>
                  </v-col>

            <!-- Описание пробы -->
            <v-col cols="12" class="mt-2">
              <v-textarea
                v-model="subjectProbe.probeDescription"
                label="Описание / Задание пробы"
                variant="outlined"
                rows="3"
                color="primary"
                density="comfortable"
              ></v-textarea>
            </v-col>

            <!-- Даты приема работ -->
            <v-col cols="12" sm="6" class="mt-2">
              <v-text-field
                v-model="subjectProbe.startTime"
                type="datetime-local"
                label="Начало приема работ*"
                variant="outlined"
                required
                color="primary"
                density="comfortable"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" class="mt-2">
              <v-text-field
                v-model="subjectProbe.endTime"
                type="datetime-local"
                label="Окончание (Дедлайн)*"
                variant="outlined"
                required
                color="primary"
                density="comfortable"
              ></v-text-field>
            </v-col>

            <!-- Подвязка ИИ-Промпта к пробе (перенесено на всю ширину для читаемости текста подсказки) -->
            <v-col cols="12" class="mt-2">
              <v-select
                v-model="subjectProbe.promptId"
                :items="availablePrompts"
                item-title="promptName"
                item-value="id"
                label="ИИ-Промпт автоматической проверки"
                clearable
                prepend-inner-icon="mdi-robot"
                variant="outlined"
                color="primary"
                density="comfortable"
                hint="Работы, сданные студентами на эту пробу, будут автоматически проверены по критериям выбранного ИИ-промпта"
                persistent-hint
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <!-- Кнопки действий -->
        <v-card-actions class="px-6 py-4 bg-grey-lighten-5">
          <v-spacer></v-spacer>
          <v-btn
            color="grey-darken-1"
            variant="outlined"
            class="px-4"
            @click="probeDialog = false"
          >
            Отмена
          </v-btn>
          <v-btn
            color="deep-orange-darken-1 "
            variant="flat"
            class="px-5 ml-2"
            :disabled="!subjectProbe.probeName || !subjectProbe.probeOrder || !subjectProbe.startTime || !subjectProbe.endTime"
            @click="saveProbe()"
          >
            Сохранить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-dialog v-model="mediaDialog" max-width="850px" width="95%" persistent>
      <v-card v-if="activeModule" class="rounded-lg overflow-hidden d-flex flex-column" style="max-height: 85vh;">
        <v-card-title class="bg-indigo-darken-4 px-4 px-md-6 py-3 text-white d-flex align-start align-sm-center justify-space-between w-100">
          <div class="d-flex align-start align-sm-center flex-column flex-sm-row text-truncate mr-2">
            <div class="d-flex align-center mb-1 mb-sm-0">
             <v-icon start class="mr-2">mdi-folder-image</v-icon>
             <span class="text-subtitle-1 font-weight-bold text-grey-lighten-3 mr-1">Медиатека:</span>
            </div>
            <span class="text-subtitle-1 text-sm-h6 font-weight-black text-truncate text-white pl-0 pl-sm-1">
             {{ activeModule.courseModuleName }}
            </span>
          </div>
          <v-btn icon="mdi-close" variant="text" color="white" density="compact" class="ml-auto ma-2" @click="closeMediaModal"></v-btn>
        </v-card-title>
        <!-- Основной контент галереи -->
        <v-card-text class="pa-4 pb-6 pa-md-6 bg-grey-lighten-4 overflow-y-auto">
          <v-row no-gutters>

          <!-- ЛЕВАЯ КОЛОНКА: Галерея текущих файлов ученика из БД -->
            <v-col cols="12" md="7" class="pa-2 mb-6">
              <div class="text-subtitle-2 font-weight-bold text-grey-darken-3 mb-2">Загруженные отчетные материалы</div>
              <div class="media-gallery-grid" v-if="videoFiles.length > 0">
                <v-card
                 v-for="(file, idx) in videoFiles"
                 :key="idx"
                 variant="outlined"
                 class="bg-white rounded-md overflow-hidden position-relative media-preview-card ma-2"
                >
                 <!-- Если файл — ВИДЕОПОТОК HLS (ИСПРАВЛЕНО: Стриминг .m3u8 с авто-постером) -->
                 <div class="video-preview-zone d-flex align-center justify-center bg-grey-darken-4 rounded-md overflow-hidden" style="height: 140px;">
                     <video
                       :poster="'https://esse2.eurekacenter.ru/' + formatServerPath(file.posterName)"
                       controls
                       playsinline
                       class="w-100 h-100 object-cover"
                       @vue:mounted="(vnode) => initHlsPlayer(vnode.el, 'https://esse2.eurekacenter.ru/' + formatServerPath(file.sourceHlsIndex))"
                     >
                       <source :src="'https://esse2.eurekacenter.ru' + formatServerPath(file.fileUrl)" type="application/x-mpegURL">
                     </video>
                 </div>
                 <!-- Интерактивный переключатель 4 разрешений (Выводится строго под плеером) -->
                 <div v-if=" availableLevels.length > 0" class="mt-2 text-right px-1">
                   <v-menu location="bottom end">
                     <template v-slot:activator="{ props }">
                       <v-btn
                         v-bind="props"
                         size="x-small"
                         variant="outlined"
                         color="grey-darken-3"
                         prepend-icon="mdi-cog-outline"
                         class="rounded-md font-weight-bold"
                         style="height: 24px; border: 1px solid rgba(0,0,0,0.15) !important;"
                       >
                         Качество: {{ currentLevelIndex === -1 ? 'Авто' : availableLevels.find(l => l.index === currentLevelIndex)?.name }}
                       </v-btn>
                     </template>
                     <!-- Выпадающий список разрешений из .m3u8 -->
                     <v-list density="compact" class="rounded-md border pa-1 bg-white">
                       <!-- Пункт Авто-выбора битрейта -->
                       <v-list-item
                         @click="changeVideoQuality(-1)"
                         :class="{ 'bg-indigo-lighten-5 font-weight-bold text-indigo-darken-4': currentLevelIndex === -1 }"
                         class="rounded-sm"
                       >
                        <v-list-item-title class="text-caption" style="font-size: 0.75rem !important;">
                        Авто (Адаптивное)
                        </v-list-item-title>
                      </v-list-item>
                      <!-- 4 разрешения из твоего файла -->
                      <v-list-item
                        v-for="level in availableLevels"
                        :key="level.index"
                        @click="changeVideoQuality(level.index)"
                        :class="{ 'bg-indigo-lighten-5 font-weight-bold text-indigo-darken-4': currentLevelIndex === level.index }"
                        class="rounded-sm"
                      >
                        <v-list-item-title class="text-caption" style="font-size: 0.75rem !important;">
                         {{ level.name }}
                        </v-list-item-title>
                      </v-list-item>
                     </v-list>
                   </v-menu>
                 </div>
                 <!-- Подпись под файлом -->
                 <div class="pa-2 bg-grey-lighten-5 border-top text-center">
                           <span class="text-caption text-grey-darken-2 font-weight-medium text-truncate d-block">
                                          Видеозапись проекта
                                        </span>
                     <!-- Пример вашей текущей карточки под видео плеером -->
                     <div v-if="file.status=='AUDIO_TRANSCRIPTED'" class="transcription-badge" @click="openTranscription(file)" style="cursor: pointer;">
                         <strong style="color: #d32f2f;">AUDIO_TRANSCRIBED</strong>
                     </div>
                 <div v-else>

               <span class="text-caption text-grey-darken-2 font-weight-medium text-truncate d-block">
                                    {{file.status}}
                                  </span>
                              </div>
                   <!-- КНОПКА УДАЛЕНИЯ МЕДИАФАЙЛА -->
                   <v-btn
                    icon="mdi-delete-outline"
                    size="x-small"
                    variant="text"
                    color="error"
                    title="Удалить этот файл из отчета"
                    @click="deleteMediaFile(file.id)"
                   ></v-btn>
                 </div>
                </v-card>
              </div>
              <!-- Заглушка, если файлов пока нет -->
              <div v-else class="d-flex flex-column align-center justify-center bg-white rounded-md border py-12 px-4 text-center h-100 min-h-220">
                    <v-icon size="large" color="grey-lighten-1" class="mb-2">mdi-image-off-outline</v-icon>
                    <span class="text-caption text-grey font-italic">Файлы видеоотчетов отсутствуют</span>
              </div>
            </v-col>
            <!-- ПРАВАЯ КОЛОНКА: Зона прикрепления новых файлов -->
            <v-col cols="12" md="5" class="pa-2 border-left-light-modal">
              <div class="text-subtitle-2 font-weight-bold text-grey-darken-3 mb-3">Прикрепить новые материалы</div>
              <div class="d-flex flex-column gap-2">
                <!-- Скрытые нативные файловые инпуты диска -->
                 <input type="file" ref="videoInputRef" accept="video/*" class="d-none" @change="uploadVideoFile" />
                 <!-- Кнопка 1: Загрузить фото -->

                 <!-- Кнопка 2: Загрузить видео -->
                 <v-btn
                  prepend-icon="mdi-video-outline"
                  variant="outlined"
                  color="amber-darken-3"
                  block
                  class="rounded-md font-weight-bold py-5 text-body-2 mt-2"
                  :disabled="downloadAnimation"
                  @click="$refs.videoInputRef.click()"
                 >
                   Прикрепить видеоролик
                 </v-btn>
              </div>
              <!--  Индикатор процентов прогресса загрузки -->
              <div class="mt-4 pa-3 bg-white rounded-md border text-center" v-if="downloadAnimation">
                <div class="text-caption font-weight-bold text-grey-darken-3 mb-1">
                  Отправка файла на сервер...
                </div>
                <v-progress-linear
                  v-model="uploadPercentage"
                  color="indigo"
                  height="8"
                  rounded
                  striped
                ></v-progress-linear>
                <span class="text-caption font-weight-black text-indigo d-block mt-1">
                  {{ uploadPercentage }}%
                </span>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="isTranscriptionModalOpen" max-width="850px" width="95%" persistent>
        <v-card class="transcription-card">
        <!-- Шапка окна -->
        <v-card-title class="transcription-header">
            <span>Транскрипция: модуль 1</span>
            <v-btn  icon="mdi-close" variant="text" color="white" density="compact" class="ml-auto ma-2"  @click="closeTranscription">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-card-title>
        <!-- Текстовый блок со скроллом -->
        <v-card-text class="transcription-body">
            <pre class="transcription-text">{{ transcriptionText }}</pre>
        </v-card-text>
        <!-- Подвал с кнопкой закрытия -->
        <v-card-actions class="transcription-footer">
        <v-btn text color="#ff5252" @click="closeTranscription">
            ЗАКРЫТЬ
        </v-btn>
        </v-card-actions>
        </v-card>
    </v-dialog>


  </div>
</template>




<script setup>
import { ref, onMounted } from 'vue';
import { formatDateTime } from "@/util/common";
import PageTitle from "@/elements/PageTitle.vue";
import TogglerOfWrapper from "@/components/elements/TogglerOfWrapper.vue";
import AppButton from "@/elements/AppButton.vue";
import { customAxios } from "@/service/customAxios";
import { usePopupStore } from "@/store/popup";

const { showError } = usePopupStore();

// Реактивные массивы для данных из БД
const courses = ref([]);
const availableGroups = ref([]);
const availablePrompts = ref([]);
const videoInputRef = ref(null);

// Переменные для интерактивного меню выбора качества видео (4 разрешения)
const availableLevels = ref([]);
const currentLevelIndex = ref(-1); // -1 означает "Автоматический выбор (ABR)"
let currentHlsInstance = null;


// Управление состоянием модальных окон
const courseDialog = ref(false);
const moduleDialog = ref(false);
const currentCourseId = ref(null);

const isTranscriptionModalOpen = ref(false);
const transcriptionText = ref('...');


const mediaDialog = ref(false);
const activeModule = ref();
const downloadAnimation = ref(false);

const uploadPercentage = ref(0);

const { showToastPopup } = usePopupStore();

const probeDialog  = ref(false);

const subjectProbe = ref({
    id: null,
    probeOrder: 1,
    probeName: '',
    probeDescription: '',
    startTime: '',
    endTime: '',
    promptId: '',
    subjectId: '',
    attemptCount: 1,
  });

  function addProbaDialog(s){
  subjectProbe.value.subjectId = s.id;
  probeDialog.value = true;

  }

function closeProbe(){
subjectProbe.value.id = '';
subjectProbe.value.probeOrder = '';
subjectProbe.value.probeName = '';
subjectProbe.value.probeDescription = '';
subjectProbe.value.startTime = '';
subjectProbe.value.endTime = '';
subjectProbe.value.promptId = '';
subjectProbe.value.subjectId = '';
probeDialog.value = false;
}

async function editProbe(probe) {
console.log("editProbe: " + probe);
subjectProbe.value.id = probe.id;
subjectProbe.value.probeOrder = probe.probeOrder;
subjectProbe.value.probeName = probe.probeName;
subjectProbe.value.probeDescription = probe.probeDescription;
subjectProbe.value.startTime = probe.startTime;
subjectProbe.value.endTime = probe.endTime;
subjectProbe.value.promptId = probe.promptId;

probeDialog.value = true;

}

async function editSubject(s) {

console.log("editSubject: " + s);


courseSubject.value.id = s.id;
courseSubject.value.courseModuleSubjectName = s.courseModuleSubjectName;
courseSubject.value.courseModuleSubjectDescription = s.courseModuleSubjectDescription;
courseSubject.value.probeDescription = s.startTime;
courseSubject.value.startTime = s.endTime;
courseSubject.value.endTime = s.endTime;


courseSubjectDialog.value = true;

}

async function deleteProbe(id) {
console.log("deleteProbe");
if (!confirm(`Вы уверены, что хотите безвозвратно удалить пробу?`)) return;
  try {

      await customAxios.delete(`/v1/courses/module/subject/probe/${id}`);


    await loadConstructorData(); // Перечитываем дерево данных
  } catch (e) {
    showError(e);
  }
}

async function saveProbe() {
console.log("saveProbe");
  try {
    if (subjectProbe.value.id) {
      await customAxios.put(`/v1/courses/module/subject/probe/${subjectProbe.value.id}`, subjectProbe.value);
    } else {
      await customAxios.post(`/v1/courses/module/subject/probe`, subjectProbe.value);
    }
    closeProbe();
    await loadConstructorData(); // Перечитываем дерево данных
  } catch (e) {
    showError(e);
  }
}


const courseSubjectDialog = ref(false);
const courseSubject = ref({
    id: null,
    courseModuleSubjectName: '',
    courseModuleSubjectDescription: '',
    startTime: '',
    endTime: '',
    courseModule: {}
  });

  async function addSubjectDialog(mod){
  courseSubject.value.courseModule = mod;
  courseSubjectDialog.value = true;
  }

async function saveSubject() {
console.log("ololo");
  try {
    if (courseSubject.value.id) {
      await customAxios.put(`/v1/courses/module/subject/${courseSubject.value.id}`, courseSubject.value);
    } else {
      await customAxios.post(`/v1/courses/module/${courseSubject.value.courseModule.id}/subject`, courseSubject.value);
    }
    courseSubjectDialog.value = false;
    await loadConstructorData(); // Перечитываем дерево данных
  } catch (e) {
    showError(e);
  }
}


// Модели форм (DTO структуры)
const courseForm = ref({
  id: null,
  courseName: '',
  courseDescription: '',
  courseStartTime: '',
  courseEndTime: '',
  personGroupIds: [] // Сюда Vuetify соберет ID выбранных групп
});

const moduleForm = ref({
  id: null,
  courseModuleName: '',
  courseModuleDescription: '',
  courseModuleStartTime: '',
  courseModuleEndTime: '',
  promptId: null // ID привязываемого промпта
});

const videoFiles = ref([]);

const openTranscription = (file) => {
    transcriptionText.value = file.audioTranscript;
  isTranscriptionModalOpen.value = true;
};
const closeTranscription = () => {
  isTranscriptionModalOpen.value = false;
};

async function deleteSubject(id) {
  if ( !id) return;

  if (!confirm(`Вы уверены, что хотите безвозвратно удалить этот предмет?`)) return;
  try {
    const r = await customAxios.delete(`/v1/courses/module/subject/${id}`);

    if (r.status === 202) {
      // 1. Обновляем общие данные формы, чтобы бэк отдал чистые новые сеты
      await loadConstructorData();
      showToastPopup ? showToastPopup("Предмет успешно удален!") : alert("Видео успешно удалено!");
    }
  } catch (e) {
    showError(e);
  }
}

async function deleteMediaFile(id) {
  if (!activeModule.value || !id) return;

  if (!confirm(`Вы уверены, что хотите безвозвратно удалить этот видеоролик?`)) return;
  try {
    const r = await customAxios.delete(`/video/upload/${id}`);

    if (r.status === 202) {
      // 1. Обновляем общие данные формы, чтобы бэк отдал чистые новые сеты
      await getCourseModule(activeModule.value.id);
      await loadConstructorData();
      showToastPopup ? showToastPopup("Видео успешно удалено!") : alert("Видео успешно удалено!");
    }
  } catch (e) {
    showError(e);
  }
}

function openVideoDialog(mod){
    activeModule.value = mod;
    videoFiles.value = mod.videoFiles;
    mediaDialog.value = true;
}

// Функция принимает грязный путь и вырезает базовую директорию сервера
function formatServerPath(path) {
  if (!path) return '';
  // Регулярное выражение находит //var/www/esse2 или /var/www/esse2
  return path.replace(/^\/{1,2}var\/www\/esse2/, '');
}





function closeMediaModal(){
 mediaDialog.value = false;
 activeModule.value = undefined;
}
/**
 * 2. Отправка ВИДЕО строго по индексу [0]
 */
async function getCourseModule(id) {
console.log("getCourseModule: " + id);
  if (!id) return;

  try {
    const res = await customAxios.get("/v1/courses/modules/" + id);
    videoFiles.value = [];

    if ( res.status === 200) {
    activeModule.value = res.data;
    videoFiles.value = res.data.videoFiles;

    }
  } catch (e) {
    showError(e);
  }
}
/**
 * 2. Отправка ВИДЕО строго по индексу [0]
 */
async function uploadVideoFile(event) {
  const file = event.target.files?.[0];
  if (!file || !activeModule.value) return;

  try {
    downloadAnimation.value = true;
    uploadPercentage.value = 0;

    let formData = new FormData();
    formData.append("file", file); // Передаем чистый файл

    const res = await customAxios.post("/video/upload/" + activeModule.value.id, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress: function(progressEvent) {
        if (progressEvent.total) {
          uploadPercentage.value = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100));
        }
      }
    });

    if (res.status === 201 ) {
      await getCourseModule(activeModule.value.id);
      showToastPopup ? showToastPopup("Видео успешно загружено!") : alert("Видео успешно загружено!");

      await loadConstructorData();
     // refreshActiveMediaGallery(); // Окно не закрывается, видео сразу готово к тестам!
    }
  } catch (e) {
    showError(e);
  } finally {
    downloadAnimation.value = false;
    if (videoInputRef.value) videoInputRef.value.value = "";
  }
}

/**
 * УНИВЕРСАЛЬНЫЙ ЗАПУСК: Hls.js
 */
function initHlsPlayer(videoElement, streamUrl) {
  if (!videoElement || !streamUrl) return;

    // Формируем путь к дочернему мультибитрейтному индексу
    let correctedStreamUrl = streamUrl;
    if (!correctedStreamUrl.includes('/ts/')) {
      correctedStreamUrl = correctedStreamUrl.replace("index.m3u8", "ts/index.m3u8");
    }


  console.log("🎬 Запуск HLS потока:", correctedStreamUrl);

  // 1. Проверяем, поддерживает ли браузер Hls.js (Chrome, Firefox, Edge, Safari на Mac)
  if (window.Hls && window.Hls.isSupported()) {
    startHlsLibrary(videoElement, correctedStreamUrl);
  }
  // 2. ФОЛБЕК НА НАТИВНЫЙ РЕЖИМ (Строго для iPhone/iPad, где Hls.js заблокирован Apple)
  else if (videoElement.canPlayType('application/vnd.apple.mpegurl')) {
    videoElement.src = correctedStreamUrl;
    videoElement.load();

    videoElement.addEventListener('loadedmetadata', () => {
      console.log("🍏 Нативный HLS запущен на iOS (Авто-выбор качества)");
      availableLevels.value = [
        { index: -1, name: 'Авто (Адаптивное)' } // На iOS переключатель заменяем на авто-чип
      ];
    });
  } else {
    // Если библиотеки еще нет в DOM (первый запуск) — инжектим её
    const script = document.createElement('script');
    script.src = '/hls.js';
    script.onload = () => initHlsPlayer(videoElement, streamUrl);
    document.head.appendChild(script);
  }
}

function changeVideoQuality(levelIndex) {
  currentLevelIndex.value = levelIndex;

  if (currentHlsInstance) {
    currentHlsInstance.currentLevel = levelIndex;
    currentHlsInstance.nextLevel = levelIndex;
    // Мгновенный разрыв старого кэша и буферизация нового разрешения
    if (currentHlsInstance.streamController?.immediateLevelSwitch) {
      currentHlsInstance.streamController.immediateLevelSwitch();
    }
    console.log(`🎬 Качество переключено через Hls.js на уровень: ${levelIndex}`);
  }
}
function startHlsLibrary(videoElement, streamUrl) {
  if (!window.Hls.isSupported()) return;

  // Очищаем старый инстанс плеера перед инициализацией нового
  if (currentHlsInstance) {
    currentHlsInstance.destroy();
  }

  const hls = new window.Hls({
    maxMaxBufferLength: 10,
    enableWorker: true
  });

  currentHlsInstance = hls;

  hls.loadSource(streamUrl);
  hls.attachMedia(videoElement);

  // Как только Hls.js прочитает наш файл /ts/index.m3u8 со всеми 4 потоками
  hls.on(window.Hls.Events.MANIFEST_PARSED, function (event, data) {
    console.log("✨ HLS Манифест распарсен. Найдено потоков качества:", data.levels.length);

    // Вытаскиваем и маппим все 4 разрешения из манифеста
    availableLevels.value = data.levels.map((level, index) => ({
      index: index,
      // Если в манифесте прописана высота (например, 720), пишем "720p", иначе "Поток "
      name: level.height ? `${level.height}p` : `Разрешение ${index + 1}`
    })).reverse(); // Разворачиваем массив, чтобы высокое качество (1080p) шло сверху

    currentLevelIndex.value = hls.currentLevel;
  });

  hls.on(window.Hls.Events.ERROR, function (event, data) {
    if (data.fatal) console.error("Критический сбой HLS:", data);
  });
}
/**
 * Комплексная загрузка данных для конструктора
 */
async function loadConstructorData() {
  try {
    const [cRes, gRes, pRes] = await Promise.all([
      customAxios.get('/v1/admin/courses/tree'), // Дерево курсов с вложенными модулями
      customAxios.get('/person/group'),             // Все доступные группы студентов
      customAxios.get('/v1/prompts')             // Вся наша библиотека промптов
    ]);

    courses.value = cRes.data || [];
    availableGroups.value = gRes.data || [];
    availablePrompts.value = pRes.data || [];
  } catch (e) {
    showError(e);
  }
}

/**
 * Открытие модалки курса (создание или редактирование)
 */
function openCourseDialog(course = null) {
  if (course) {
    courseForm.value = {
      id: course.id,
      courseName: course.courseName,
      courseDescription: course.courseDescription,
      // Инпуты datetime-local требуют строго формат YYYY-MM-DDTHH:mm (16 символов)
      courseStartTime: course.courseStartTime ? course.courseStartTime.substring(0, 16) : '',
      courseEndTime: course.courseEndTime ? course.courseEndTime.substring(0, 16) : '',
      // Маппим пришедшие объекты групп в плоский массив их ID для v-select
      personGroupIds: course.coursePersonGroups ? course.coursePersonGroups.map(g => g.id) : []
    };
  } else {
    courseForm.value = { id: null, courseName: '', courseDescription: '', courseStartTime: '', courseEndTime: '', personGroupIds: [] };
  }
  courseDialog.value = true;
}

/**
 * Открытие модалки модуля
 */
function openModuleDialog(courseId, mod = null) {
  currentCourseId.value = courseId;
  if (mod) {
    moduleForm.value = {
      id: mod.id,
      courseModuleName: mod.courseModuleName,
      courseModuleDescription: mod.courseModuleDescription,
      // Форматируем даты под стандарт datetime-local
      courseModuleStartTime: mod.courseModuleStartTime ? mod.courseModuleStartTime.substring(0, 16) : '',
      courseModuleEndTime: mod.courseModuleEndTime ? mod.courseModuleEndTime.substring(0, 16) : '',
      promptId: mod.promptId || null
    };
  } else {
    moduleForm.value = { id: null, courseModuleName: '', courseModuleDescription: '', courseModuleStartTime: '', courseModuleEndTime: '', promptId: null };
  }
  moduleDialog.value = true;
}

/**
 * Сохранение курса на бэкенде (POST или PUT)
 */
async function saveCourse() {
  try {
    if (courseForm.value.id) {
      await customAxios.put(`/v1/admin/courses/${courseForm.value.id}`, courseForm.value);
    } else {
      await customAxios.post('/v1/admin/courses', courseForm.value);
    }
    courseDialog.value = false;
    await loadConstructorData(); // Перечитываем дерево данных
  } catch (e) {
    showError(e);
  }
}

/**
 * Сохранение модуля на бэкенде (POST или PUT)
 */
async function saveModule() {
  try {
    if (moduleForm.value.id) {
      await customAxios.put(`/v1/admin/courses/${currentCourseId.value}/modules/${moduleForm.value.id}`, moduleForm.value);
    } else {
      await customAxios.post(`/v1/admin/courses/${currentCourseId.value}/modules`, moduleForm.value);
    }
    moduleDialog.value = false;
    await loadConstructorData(); // Перечитываем дерево данных
  } catch (e) {
    showError(e);
  }
}

onMounted(async () => {
  await loadConstructorData();
});
</script>

<style scoped>
/* Сетки и отступы */
.gap-1 {
  gap: 4px !important;
}
.gap-2 {
  gap: 8px !important;
}
.gap-4 {
  gap: 16px !important;
}
.w-100 {
  width: 100% !important;
}
.flex-grow-1 {
  flex-grow: 1 !important;
}

/* Элементы списков */
.border-bottom {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
.border-bottom:last-child {
  border-bottom: none;
}

/* Синяя шапка (Транскрипция) */
.transcription-header {
  background-color: #1a237e !important;
  color: #ffffff !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px !important;
}

/* Ограничение высоты текста и авто-скролл */
.transcription-body {
  padding: 24px !important;
  max-height: 400px;
  overflow-y: auto;
}

/* Правильное отображение переносов строк */
.transcription-text {
  margin: 0;
  font-size: 16px;
  line-height: 1.6;
  color: #333333;
  white-space: pre-wrap; /* Сохраняет абзацы из БД */
}

/* Выравнивание кнопки в подвале */
.transcription-footer {
  justify-content: flex-end;
  padding: 8px 16px !important;
  border-top: 1px solid #eeeeee;
}

/* --- СТИЛИ ДЛЯ КАРТОЧЕК ПРЕДМЕТОВ (Новые и исправленные) --- */
.custom-subject-card {
  border-color: #e0e0e0 !important;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 180px; /* Защита от схлопывания, когда предметов мало или они пустые */
  transition: all 0.2s ease-in-out;
}

.custom-subject-card:hover {
  border-color: #b2dfdb !important; /* Легкое подсвечивание при наведении */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.border-dashed {
  border: 1px dashed #cfd8dc !important;
}

.line-height-tight {
  line-height: 1.25;
}

.rounded-md {
  border-radius: 6px !important;
}

.elevation-sm {
  box-shadow: 0 1px 3px rgba(0,0,0,0.05) !important;
}

.text-truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.gap-3 {
  gap: 12px !important;
}

.custom-subject-card {
  border-color: #e0e0e0 !important;
  display: flex !important;
  flex-direction: column;
  width: 100% !important; /* Форсирует растягивание на весь родительский блок */
  min-width: 100% !important;
  min-height: 180px;
  transition: all 0.2s ease-in-out;
}
/* Добавьте к вашим текущим стилям */
.custom-proba-card {
  transition: border-color 0.2s ease-in-out;
}
.custom-proba-card:hover {
  border-color: #b2dfdb !important;
}
.border-top-light {
  border-top: 1px solid #f5f5f5;
}
.custom-description-block {
  white-space: pre-wrap;
  border-left: 3px solid #e0e0e0;
}
</style>
